import React, { Component } from "react";
import { observer } from "mobx-react";
import FilterGroup from "./FilterGroup";
import ShiftFilter from "./options/ShiftFilter";

class ShiftModelCriteria extends Component {
  render() {
    const { store } = this.props;

    return (
      <FilterGroup large title="Model Criteria">
        <ShiftFilter store={store} />
      </FilterGroup>
    );
  }
}

export default observer(ShiftModelCriteria);



// WEBPACK FOOTER //
// ./src/components/filters/ShiftModelCriteria.js